import React, { useContext, useState } from "react";
import { AppointmentContext } from "../context/AppointmentContext";

const hospitals = [
  {
    name: "hazra",
    label: "Chittaranjan National Cancer Institute, Hazra, Kolkata",
  },
  {
    name: "newtown",
    label: "Chittaranjan National Cancer Institute, New Town, Kolkata",
  },
];

function Pagefirst({ onNext, onReset }) {
  const { setHospitalName } = useContext(AppointmentContext);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSelect = (name) => {
    setHospitalName(name);
    sessionStorage.setItem("selectedHospital", name); 
    onNext();
  };

  const filteredHospitals = hospitals.filter((hospital) =>
    hospital.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body">
        <h5 className="card-title mb-3">
          <i class="fa-solid fa-hospital"></i>&nbsp;
          Select Hospital</h5>

        {/* Search Input */}
        <div className="mb-3">
          <label className="form-label">Type Hospital Name</label>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Enter Hospital Name"
            className="form-control hospital-search"
            style={{
              borderRadius: "0px",
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              borderBottom: "2px solid #313fcc",
            }}
          />
        </div>

        {/* Filtered List */}
        <div
          className="list-group mb-4"
          style={{ maxHeight: "200px", overflowY: "auto", marginTop: "30px" }}
        >
          {filteredHospitals.length > 0 ? (
            filteredHospitals.map((hospital, index) => (
              <div className="custom-option" role="button" key={index}>
                <div
        onClick={() => handleSelect(hospital.name)}
        className={`list-group-item hospital-item mb-2 d-flex justify-content-between align-items-center ${
          index === 0
            ? "list-group-item-success"
            : index === 1
            ? "list-group-item-info"
            : ""
        }`}
        style={{ cursor: "pointer" }}
      >
                  <div className="fw-semibold">
                    <span>{hospital.label}</span>
                  </div>
                  <i className="fa fa-chevron-right text-dark"></i>
                </div>
              </div>
            ))
          ) : (
            <div className="text-muted px-3">No hospitals found.</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Pagefirst;
